module.exports = __webpack_public_path__ + "static/onguard-logo-77d0f36e11e097a2e8f074cadccb65d0.png";